import { useCallback } from 'react'
import { useClientDashboardLogin } from '../../providers/ClientDashboardLoginProvider/ClientDashboardLoginProvider'

export const useClientDashboardLoginOverlayTrigger = () => {
  const { openLoginOverlay } = useClientDashboardLogin()

  const openOverlayInsteadOfNavigating = useCallback(
    (e) => {
      e.preventDefault()
      openLoginOverlay()

      return true
    },
    [openLoginOverlay]
  )

  return { overlayEnabled: true, openOverlayInsteadOfNavigating }
}
